<div class="row g-0 m-0 m-4 mb-4 d-flex align-items-center justify-content-between">
    <!-- Device name, type and status -->
    <div class="col-auto d-flex align-items-center ps-4">
        <div class="button-back me-3" (click)="goBack()">
            <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
        </div>
        <div class="d-flex flex-column w-auto">
            <h6 class="title">{{row!.meterMake ?? ''}} {{row!.meterNo ?? ''}}</h6>
            <h2 class="subtitle m-0">
                {{row!.assetTypeName ?? '/'}}
            </h2>
        </div>
        <span class="status-badge ms-4" [class.online]="row!.status" [class.offline]="!row!.status">
            <img class="status-dot"
                [src]="row!.status ? 'assets/device/online-dot.svg' : 'assets/device/offline-dot.svg'" alt="" />
            {{ row!.status ? 'Online' : 'Offline' }}
        </span>
    </div>

    <!-- Action buttons -->
    <div class="col-auto d-flex gap-1">
        @if (authService.isAuthorized([PermissionsEnum.Remotecommands_connectdisconnect_execute])) {
        <button class="action-button" [disabled]="isRelayPending" (click)="askToSetRelayState()">
            {{ relayActionKey | translate }}
        </button>
        }
        <button class="action-button" (click)="askToPing()">
            {{ 'PING' | translate }}
        </button>
        @if(authService.isAuthorized([PermissionsEnum.Ondemand_loadprofile_execute])){
            <button class="action-button" (click)="askToRunRead()">{{ 'RUN_READ' | translate }}</button>
        }
        <button class="action-button" (click)="askToRunDiagnostics()">
            {{ 'RUN_DIAGNOSTICS' | translate }}
        </button>
    </div>
</div>

<app-confirm-dialog *ngIf="isRelayConfirmOpen" [titleKey]="relayActionKey"
    [question]="isRelayConnected ? 'DISCONNECT_CONFIRM' : 'CONNECT_CONFIRM'"
    (confirm)="setRelayState()" (cancel)="closeRelayConfirm()"></app-confirm-dialog>
<app-confirm-dialog *ngIf="isPingConfirmOpen" titleKey="PING" question="PING_CONFIRM"
    (confirm)="pingMeter()" (cancel)="closePingConfirm()"></app-confirm-dialog>

<div class="container-fluid modal" *ngIf="isPingConfirmOpen">
    <div class="row g-0 m-0 modal-content d-flex justify-content-center p-2">
        <h5 class="popup-title d-flex justify-content-center m-0 p-2">{{ "PING_CONFIRM" | translate }}</h5>
        <div class="row g-0 m-0 d-flex justify-content-center p-3 gap-5">
            <button class="button-style-green" (click)="pingMeter()">{{ "DEVICES_YES" | translate }}</button>
            <button class="button-style-red" (click)="closePingConfirm()">{{ "DEVICES_NO" | translate }}</button>
        </div>
    </div>
</div>

<div class="container-fluid modal" *ngIf="isRunReadConfirmOpen">
    <div class="row g-0 m-0 modal-content d-flex justify-content-center p-2">
        <h5 class="popup-title d-flex justify-content-center m-0 p-2">{{ "RUN_READ_CONFIRM" | translate }}</h5>
        <div class="row g-0 m-0 d-flex justify-content-center p-3 gap-5">
            <button class="button-style-green" (click)="runRead()">{{ "DEVICES_YES" | translate }}</button>
            <button class="button-style-red" (click)="closeRunReadConfirm()">{{ "DEVICES_NO" | translate }}</button>
        </div>
    </div>
</div>


<div class="container-fluid modal" *ngIf="isDiagnosticsConfirmOpen">
    <div class="row g-0 m-0 modal-content d-flex justify-content-center p-2">
        <h5 class="popup-title d-flex justify-content-center m-0 p-2">{{ "RUN_DIAGNOSTICS_CONFIRM" | translate }}</h5>
        <div class="row g-0 m-0 d-flex justify-content-center p-3 gap-5">
            <button class="button-style-green" (click)="runDiagnostics()">{{ "DEVICES_YES" | translate }}</button>
            <button class="button-style-red" (click)="closeDiagnosticsConfirm()">{{ "DEVICES_NO" | translate }}</button>
        </div>
    </div>
</div>

<app-confirm-dialog *ngIf="isDiagnosticsConfirmOpen" titleKey="RUN_DIAGNOSTICS" question="RUN_DIAGNOSTICS_CONFIRM"
    (confirm)="runDiagnostics()" (cancel)="closeDiagnosticsConfirm()"></app-confirm-dialog>

@if (isDiagnosticsModalOpen) {
<app-diagnostics-modal [status]="diagnosticsStatus" [errorMessage]="diagnosticsErrorMessage" [steps]="diagnosticsSteps"
    (closeSignal)="isDiagnosticsModalOpen = false"></app-diagnostics-modal>
}

<!-- Tabs -->
<div class="row g-0 pb-3">
    <ul>
        <li *ngFor="let tab of tabs" [class.active]="activeTab === tab.id" (click)="selectTab(tab.id)">
            {{ tab.labelKey | translate }}
        </li>
    </ul>
</div>

<!-- Tab content -->
<div class="tab-content">
    @if (activeTab === 'Device Details') {
    <div class="row g-0 m-0 h-100 d-flex justify-content-center">
        <app-device-information [deviceId]="row!.id!" [embedded]="true"></app-device-information>
    </div>
    }
    @if (activeTab === 'Load Profile') {
    <div class="row g-0 m-0 pb-3">
        <app-load-profile [meterId]="row!.id!"></app-load-profile>
    </div>
    }
    @if (activeTab === 'Connectivity') {
    <div class="row g-0 m-0 d-flex justify-content-center">
        <app-connectivity [meterId]="row!.id!"></app-connectivity>
    </div>
    }
    @if (activeTab === 'Events & Alarms') {
    <div class="row g-0 m-0 pb-3">
        <app-events-alarms [meterNo]="row!.meterNo!"></app-events-alarms>
    </div>
    }
    @if (activeTab === 'Commands') {
    <div class="row g-0 m-0 d-flex justify-content-center">
        <app-commands [meterId]="row!.id!"></app-commands>
    </div>
    }
    @if (activeTab === 'Tokens') {
    <div class="row g-0 m-0 d-flex justify-content-center">
        <app-tokens [meterId]="row!.id!"></app-tokens>
    </div>
    }
    @if (activeTab === 'Event Logs') {
    <div class="row g-0 m-0 pb-3">
        <app-event-logs [meterId]="row!.id!"></app-event-logs>
    </div>
    }
</div>

@if (isRunReadModalOpen) {
<app-run-read-modal [commandId]="runReadCommandId!" (closeSignal)="closeRunReadModal()"></app-run-read-modal>
}